
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface CompanyInfoSectionProps {
  companyName: string;
  jobTitle: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CompanyInfoSection = ({ companyName, jobTitle, onChange }: CompanyInfoSectionProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="companyName">Company Name *</Label>
        <Input 
          id="companyName" 
          name="companyName" 
          value={companyName} 
          onChange={onChange} 
          required 
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="jobTitle">Job Title *</Label>
        <Input 
          id="jobTitle" 
          name="jobTitle" 
          value={jobTitle} 
          onChange={onChange} 
          required 
        />
      </div>
    </div>
  );
};

export default CompanyInfoSection;
